import React from "react";
import type { ViewsConfiguration, BackgroundOptions } from '../../../model/Configuration';
import { useViewsConfiguration } from '../../../redux/Hooks/';
import { viewsConfigurationChangeAction } from "../../../redux/Actions";
import { useDispatchKiosk } from "../../../redux/Hooks/Kiosk/useDispatchKiosk";
import { useLocale } from "@davi-ai/retorik-framework";
import translation from '../../../translations/subMenuItems.json'
import Button from "../../Common/Button";
import tempViewsConfigurationChangeAction from "../../../redux/Actions/Kiosk/tempViewsConfigurationChangeAction";

const Webcam = (props: { inputs: Array<MediaDeviceInfo>, from: string }) => {
  const locale = useLocale();
  const viewsConfiguration: ViewsConfiguration = useViewsConfiguration();
  const dispatch = useDispatchKiosk();

  const handleChoose = (deviceId: string) => {
    try {
      const tempData = { ...viewsConfiguration };
      const from = props.from;
      const background: BackgroundOptions = {
        ...viewsConfiguration.views[from].background,
        style: 'webcam',
        webcam: deviceId
      }
      tempData.views[from].background = background;    
      
      dispatch(viewsConfigurationChangeAction(tempData));
      dispatch(tempViewsConfigurationChangeAction(from === 'home' ?
        {
          home: {
            background: {
              style: 'webcam',
              webcam: deviceId
            }
          }
        } : {
          news: {
            background: {
              style: 'webcam',
              webcam: deviceId
            }
          }
        }));
    } catch(error) {
      console.log(error);
    }
  }

  return (
    <div className="w-full flex flex-col gap-1 my-1 px-4">
        {translation[locale]?.background.webcamchoice || translation["fr-FR"].background.webcamchoice} :
        {props.inputs?.map((input, i) => {
          return (
            <Button key={i} onClick={() => handleChoose(input.deviceId)} label="Choose">
              {input.label}
            </Button>
          )
        })}
    </div>
  );
};

export default Webcam;
